import { render, staticRenderFns } from "./SobreNos.vue?vue&type=template&id=497631c2&scoped=true&"
import script from "./SobreNos.vue?vue&type=script&lang=js&"
export * from "./SobreNos.vue?vue&type=script&lang=js&"
import style0 from "./SobreNos.vue?vue&type=style&index=0&id=497631c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497631c2",
  null
  
)

export default component.exports